import config from '../config';
import { getOrgStore } from '../models/useOrgModel';
import { getUtcOffsetStore } from '../models/useUtcOffsetModel';

const getOrgsMap = () => getOrgStore()?.orgsMap || new Map<string, string>();

const getOrgsArr = () => getOrgStore()?.orgs || [];

const getUtcOffset = () =>
  getUtcOffsetStore()?.offset ||
  localStorage.getItem('casUtcOffset') ||
  config.ui.timeZone.defaultOffset;

export const globalStoreGetter = {
  getOrgsMap,
  getOrgsArr,
  getUtcOffset,
};
